import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { playTaskChime } from "@/lib/sound";
import { ClipboardList } from "lucide-react";

const fmtDue = (d) => {
  try { return new Date(d).toLocaleDateString("nl-NL", { day: "numeric", month: "short" }); }
  catch { return d; }
};

// Poll: popup + geluid zodra iemand anders een taak aan mij toewijst.
export default function TaskNotifications() {
  const navigate = useNavigate();

  useEffect(() => {
    let stopped = false;
    const poll = async () => {
      try {
        const { data } = await api.get("/tasks/assigned-notifications");
        if (stopped || !data?.length) return;
        api.post("/tasks/notifications/ack", { ids: data.map((t) => t.id) }).catch(() => {});
        playTaskChime();
        data.forEach((t) => {
          const who = (t.owner_email || "").split("@")[0];
          toast(`Nieuwe taak van ${who.charAt(0).toUpperCase() + who.slice(1)}`, {
            id: `task-notif-${t.id}`,
            description: [t.title, t.customer_name, t.due_date && `deadline ${fmtDue(t.due_date)}`]
              .filter(Boolean).join(" · "),
            icon: <ClipboardList className="h-4 w-4 text-blue-700" />,
            duration: 15000,
            action: { label: "Bekijk", onClick: () => navigate("/tasks") },
          });
        });
      } catch { /* stil — volgende poll probeert opnieuw */ }
    };
    poll();
    const id = setInterval(poll, 45000);
    return () => { stopped = true; clearInterval(id); };
  }, [navigate]);

  return null;
}
